
import { useDispatch, useSelector } from "react-redux";
import {
  OnSignIn,
  onSignOut,
 
  setUserDet,
  setExperienceData,
  setWorkPerformance,
  setConstructionData
} from "../core/data/redux/authSlice";
import { jwtDecode } from "jwt-decode";

// import { getUserAreaDeatils } from "../Services/ApiCalling";
import { getOtpforResendinlogin, login, loginContractFarming } from "../feature-module/auth/services/Un_auth_services";

function useAuth() {
  const token = useSelector((state) => state.auth.token);
  //.log("tiokenn", token);
  const isSignedIn = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();

  // //.log("OnSignInOnSignIn",OnSignIn)

  const signIn = async (values) => {
    //.log("credentials", values);
    let   Username=values.UserName, refId  = values.refId;
    let body, password = values.password,userType= values.userType



    if(values.Email) {
      body = {Email: values.Email, password, userType};
    } else {
      body = {UserName: values.Username, password,userType};
    }

    //.log("body login", body);

        let response;
    if (refId) {
           
        response = await getOtpforResendinlogin({ UserName: Username, password, userType, refId });
        } else {
           
            response = userType==="Contract_Farming_Login"? await loginContractFarming(body): await login(body);
        }

   
    if (response?.success === true ) {
      dispatch(OnSignIn(response.Body));
      // if (response.Body) {
      //   let areaDet = await setUserDet(response.Body);
      //   //.log("areaDetareaDetareaDetareaDetareaDet", areaDet);
      //   dispatch(setUserAreaDet(areaDet.data));
      // }

      const decodedToken = jwtDecode(response.Body);
      //.log("decodeddd tokennn  111111111", decodedToken);

     
        dispatch(setUserDet(decodedToken));
        //.log('disssss')
      

      // let currTime = new Date().getTime();
      // // currTime = currTime + 7200000; 
      // currTime = currTime + 36000000; //36,000,000

      // localStorage.setItem("tokenExpTime", currTime.toString());
      // 36000000
      let currTime = new Date().getTime();
      currTime = currTime + 36000000;
      // currTime = currTime + 20000;
      localStorage.setItem("tokenExpTime", currTime.toString());


      //.log("decodeddd tokennn", decodedToken);
      // dispatch(setUserDet(decodedToken));
      return response;
    }else if(response.success === false){
        // alert(response.Message);retur
        return response
    }
    
    else if (response.Error) {
      //.log("else condition");
      return response;
    }
    else{
      return response;
    }
  }; 

  const signOut = () => {
    // localStorage.removeItem("tokenExpTime");
    dispatch(onSignOut());
    dispatch(setUserDet({}))
    dispatch(setExperienceData({}))
    dispatch(setWorkPerformance({}))
    dispatch(setConstructionData({}))
    //.log("token after signout", token);

  };

  return { token, signIn, signOut, isSignedIn };
}

export default useAuth;
